module.exports = __webpack_public_path__ + "static/img/identity_card.1cbadfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/identity_card.png
// module id = 0o/z
// module chunks = 1